import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';

import { ArtifactCard, Loader, Pagination } from 'ui';

const useStyles = makeStyles(theme => ({
  artifactCard: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

const Artifacts = ({
  isPending,
  data,
  total,
  limit,
  onItemClick,
  onItemRemove,
  onChangePage,
  currentPage,
  onChangeRowsPerPage,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const pagesTotal =
    Number.isInteger(total) && Number.isInteger(limit) ? Math.ceil(total / limit) : undefined;
  const visibleArtifacts = data.filter(({ publicationDate, title }) => publicationDate || title);

  return (
    <>
      {isPending ? (
        <Loader center />
      ) : (
        <div>
          {visibleArtifacts.length > 0 ? (
            <>
              {visibleArtifacts.map(
                ({ publicationDate, title, teaser, type, artifactId, id, restricted }) => (
                  <ArtifactCard
                    key={id}
                    className={classes.artifactCard}
                    onClick={() => onItemClick(artifactId || id)}
                    onRemove={onItemRemove ? () => onItemRemove([id]) : null}
                    publicationDate={publicationDate}
                    title={title}
                    teaser={teaser}
                    type={type}
                    restricted={restricted}
                  />
                ),
              )}
              {pagesTotal ? (
                <Pagination
                  onChange={onChangePage}
                  count={pagesTotal}
                  page={currentPage}
                  rowsPerPage={limit}
                  onChangeRowsPerPage={onChangeRowsPerPage}
                  showSelectPerPage
                />
              ) : null}
            </>
          ) : (
            t('There are no related news.')
          )}
        </div>
      )}
    </>
  );
};

Artifacts.defaultProps = {
  isPending: false,
  total: null,
  limit: null,
  onChangePage: () => null,
  onItemClick: () => null,
  onItemRemove: null,
  onChangeRowsPerPage: undefined,
};

Artifacts.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      publicationDate: PropTypes.string.isRequired,
      title: PropTypes.string,
      teaser: PropTypes.string,
      type: PropTypes.oneOf([
        'COMMENTARY',
        'COMPANY_NEWS',
        'RATING_NEWS',
        'RESEARCH',
        'MONITORING_NOTES',
      ]),
      relatedArtifacts: PropTypes.arrayOf(PropTypes.object),
      restricted: PropTypes.bool,
    }),
  ).isRequired,
  currentPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func,
  onItemClick: PropTypes.func,
  onItemRemove: PropTypes.func,
  isPending: PropTypes.bool,
  total: PropTypes.number,
  limit: PropTypes.number,
  onChangeRowsPerPage: PropTypes.func,
};

export default Artifacts;
